import React from 'react';
import Modal from '@salesforce/design-system-react/components/modal';
import Button from '@salesforce/design-system-react/components/button';

const ReactivateAccount = (props) => {
  const { account, isOpen, toggleOpen, onConfirm, isLoading, type } = props;

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      size="small"
      containerClassName="small-modal"
      // prompt="info"
      footer={[
        <Button className='modal-cancel-button' key="cancel" label="Cancel" onClick={toggleOpen} />,
        <Button
          className='modal-save-button'
          key="save"
          label={isLoading ? <span>Loading</span> : <span>{'Confirm'}</span>}
          disabled={isLoading}
          onClick={() => onConfirm(account._id)}
        />,
      ]}
      onRequestClose={toggleOpen}
      heading={'Enable Account'}
    >
      <section className="slds-p-around_large">
        <p className="mb-10">
          {type === 'exchange' ? 'Exchange' : 'Account'} with the{' '}
          {type === 'exchange' ? 'API key' : 'address'} you entered already exists in disabled state
          with name <b>{account.name}</b>. Do you want to enable it?
        </p>
      </section>
    </Modal>
  );
};

export default ReactivateAccount;
